import { motion, useMotionValue } from "framer-motion"
import { useLocalStorage } from "../../../utils/hooks/useLocalStorage";

export const LOCAL_STORAGE_KEY_HOME_ANIMATION_VISIBLE = 'homeAnimationVisible';

const tickVariants = {
  clicked: {
    pathLength: 1,
    stroke: '#A38D70',
    strokeWidth: 1,
    fill: '#A38D70',
    fillOpacity: 1,
    transition: {
      duration: 2,
      ease: 'easeIn'
    }
  },
  unclicked: {
    pathLength: 0,
    stroke: '#808080',
    strokeWidth: 3,
    fill: '#808080',
    fillOpacity: 0,
  }
};

const Logo = () => {
  const [isAnimationVisible,] = useLocalStorage(LOCAL_STORAGE_KEY_HOME_ANIMATION_VISIBLE, true);
  const pathLength = useMotionValue(0);

  return isAnimationVisible ? (
    <motion.svg
      width="246"
      height="270"
      viewBox="0 0 246 270"
      initial={"unclicked"}
      animate={"clicked"}
      className="mt-[-20%]"
    >
      <motion.path
        d="M147.102 41.957L172.449 105.477C171.129 116.129 168.34 123.391 165.262 128.395L130.809 42.0703L104.488 113.301L110.699 152.859H111.559C132.641 152.859 155.012 152.273 168.211 135.773C168.91 134.898 169.578 133.984 170.219 133.02C170.25 132.98 170.27 132.941 170.301 132.902C170.512 132.59 170.711 132.273 170.91 131.949C170.922 131.941 170.93 131.934 170.93 131.926C171.551 130.938 172.141 129.898 172.699 128.816C172.73 128.762 172.762 128.711 172.781 128.66C172.961 128.309 173.141 127.949 173.32 127.59C173.32 127.582 173.32 127.578 173.328 127.57C173.871 126.449 174.379 125.277 174.859 124.055C174.879 123.984 174.91 123.922 174.941 123.852C175.09 123.461 175.238 123.062 175.391 122.656C175.84 121.391 176.27 120.074 176.66 118.703C176.691 118.617 176.711 118.531 176.738 118.445C176.859 118.012 176.98 117.574 177.102 117.129C178.922 110.125 179.93 101.758 179.93 91.7422C179.93 60.5273 165.102 47.0469 147.102 41.957ZM59.9297 221.789L21.1406 20.3047H36.2109L39.2109 36.4727C63.5508 13.3281 97.7188 0.488281 137.23 0.488281C170.441 0.488281 199.461 6.07031 228.488 20.3047L224.578 40.9531C211.191 19.1875 178.262 4.67578 136.949 4.67578C102.57 4.67578 65.7109 18.6641 41.6211 49.4219L67.5508 188.996L122.961 39.3203C113.281 39.5859 103.391 41.332 93.6016 43.8633L99.7109 82.8281L89.3203 110.887L78.3516 40.9531C94.1094 36.6328 108.262 33.2461 125.422 32.6758L131.648 15.8398H136.672L143.711 33.457C174.23 37.6484 196.391 56.9492 196.391 91.7422C196.391 111.23 191.898 125.297 184.379 135.379L205.922 189.363L237.422 20.3047H245.789L207 221.789H202.531L172.559 146.672C157.621 156.879 137.32 159.559 116.578 159.559H111.75L125.23 245.512H110.441L94.1094 141.395L64.3984 221.789H59.9297ZM225.98 220.395V250.535C200.301 265.605 166.262 269.512 137.512 269.512C44.5781 269.512 0.210938 204.488 0.210938 135C0.210938 104.758 7.91016 78.6797 21.5312 57.75L25.3594 77.6484C18.8008 93.8242 15 112.875 15 135C15 221.789 79.4609 265.047 136.949 265.047C169.051 265.047 205.051 256.117 225.98 220.395Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        variants={tickVariants}
        style={{ pathLength }}
      />
    </motion.svg>
  ) : null;
}

export default Logo;
